import { Button, ButtonGroup, H3, P } from "@adfenix/alexandria";
import { Modal } from "components/Modal";
import { useTranslation } from "react-i18next";

export const InviteSellerModal = ({
  inviteSellerModal,
  setInviteSellerModal,
  inviteSeller,
  loading
}: {
  inviteSellerModal: boolean;
  setInviteSellerModal: (show: boolean) => void;
  inviteSeller: () => void;
  loading: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <Modal show={inviteSellerModal} onClose={() => setInviteSellerModal(false)}>
      <Modal.Card>
        <Modal.Card.Head onClose={() => setInviteSellerModal(false)}>
          <Modal.Card.Title style={{ width: "100%", textAlign: "center" }}>
            <H3>{t("seller.choice.inviteSeller.modal.title")}</H3>
          </Modal.Card.Title>
        </Modal.Card.Head>
        <Modal.Card.Body>
          <P>{t("seller.choice.inviteSeller.modal.description")}</P>
        </Modal.Card.Body>
        <Modal.Card.Foot style={{ alignItems: "end" }}>
          <ButtonGroup>
            <Button
              variant="secondary"
              logLabel="invite-seller-modal-cancel"
              onClick={() => setInviteSellerModal(false)}
              disabled={loading}
            >
              {t("seller.choice.inviteSeller.modal.cancel")}
            </Button>
            <Button
              logLabel="invite-seller-modal-submit"
              onClick={() => inviteSeller()}
              isLoading={loading}
            >
              {t("seller.choice.inviteSeller.modal.submit")}
            </Button>
          </ButtonGroup>
        </Modal.Card.Foot>
      </Modal.Card>
    </Modal>
  );
};
